import Vue from "vue";
import VueRouter, {RouteConfig} from "vue-router";
import Home from "../views/Home.vue";
import i18n from "@/i18n";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
	{
		path: "/",
		name: "Home",
		redirect: {name: 'login'}
	}, {
		path: "/public",
		component: () => import("../views/public/Public.vue"),
		children: [
			{
				path: "",
				redirect: {name: "login"},
			}, {
				path: "login",
				name: "login",
				component: () => import("../views/public/login/Login.vue"),
				meta: {
					title: i18n.t("login"),
				}
			}, {
				path: "login-verification",
				name: "verification",
				component: () => import("../views/public/login/Verification.vue"),
				meta: {
					title: i18n.t("verification"),
				}
			}, {
				path: "lost-password",
				name: "lostPassword",
				component: () => import("../views/public/login/LostPassword.vue"),
				meta: {
					title: i18n.t("lost_password"),
				}
			}, {
				path: "reset-password/:id/:token",
				name: "resetPassword",
				component: () => import("../views/public/login/ResetPassword.vue"),
				meta: {
					title: i18n.t("password_reset"),
				}
			}, {
				path: "partnership/:loginToken?",
				name: "partnership",
				component: () => import("../views/public/login/Partnership.vue"),
			},
		]
	}, {
		path: "/",
		component: () => import("../views/private/Private.vue"),
		children: [
			{
				path: "",
				redirect: {name: "dashboard"},
			}, {
				path: "dashboard",
				name: "dashboard",
				component: () => import("../views/private/dashboard/Dashboard.vue"),
				meta: {
					title: i18n.t("dashboard"),
				}
			}, {
				path: "assets",
				name: "assets",
				component: () => import("../views/private/assets/Assets.vue"),
				meta: {
					title: i18n.t("assets"),
				}
			}, {
				path: "transactions",
				component: () => import("../views/private/transactions/Transactions.vue"),
				children: [
					{
						path: "",
						redirect: {name: "transactions"},
					}, {
						path: "list",
						name: "transactions",
						component: () => import("../views/private/transactions/List.vue"),
						meta: {
							title: i18n.t("transactions"),
						}
					}, {
						path: "trades",
						name: "trades",
						component: () => import("../views/private/transactions/Trades.vue"),
						meta: {
							title: i18n.t("trades"),
						}
					}, {
						path: "conversions",
						name: "conversions",
						component: () => import("../views/private/transactions/Conversions.vue"),
						meta: {
							title: i18n.t("conversions"),
						}
					}
				]
			}, {
				path: "profile",
				name: "profile",
				component: () => import("../views/private/profile/Profile.vue"),
				meta: {
					title: i18n.t("profile")
				}
			}, {
				path: "inbox",
				component: () => import("../views/private/inbox/Inbox.vue"),
				children: [
					{
						path: "",
						redirect: {name: "messages"},
					}, {
						path: "messages",
						name: "messages",
						component: () => import("../views/private/inbox/Messages.vue"),
						meta: {
							title: i18n.t("messages")
						}
					}, {
						path: "messages/:id?",
						name: "messageDetail",
						component: () => import("../views/private/inbox/MessageDetail.vue"),
						meta: {
							title: i18n.t("messages")
						}
					}, {
						path: "reports",
						name: "reports",
						component: () => import("../views/private/inbox/Reports.vue"),
						meta: {
							title: i18n.t("messages")
						}
					}, {
						path: "reports/:id?",
						name: "reportDetail",
						component: () => import("../views/private/inbox/ReportDetail.vue"),
						meta: {
							title: i18n.t("messages")
						}
					}, {
						path: "instructions",
						name: "instructions",
						component: () => import("../views/private/inbox/Instructions.vue"),
						meta: {
							title: i18n.t("instructions")
						}
					}, {
						path: "instructions/:id?",
						name: "instructionDetail",
						component: () => import("../views/private/inbox/InstructionDetail.vue"),
						meta: {
							title: i18n.t("instruction")
						}
					}, {
						path: "confirmations",
						name: "confirmations",
						component: () => import("../views/private/inbox/Confirmations.vue"),
						meta: {
							title: i18n.t("trade_confirmations")
						}
					}, {
						path: "confirmations/:id?",
						name: "confirmationDetail",
						component: () => import("../views/private/inbox/ConfirmationDetail.vue"),
						meta: {
							title: i18n.t("trade_confirmation")
						}
					}, {
						path: "contracts",
						name: "contracts",
						component: () => import("../views/private/inbox/Contracts.vue"),
						meta: {
							title: i18n.t("contracts")
						}
					}
				]
			}
		]
	},
	{
		path: "/service-down",
		name: "serviceDown",
		component: () => import("../views/public/ServiceDown.vue"),
	}
];

const router = new VueRouter({
	// mode: "history",
	base: process.env.BASE_URL,
	routes
});

export default router;
